import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=3b190718&scoped=true"
import script from "./IdentityForm.vue?vue&type=script&lang=ts"
export * from "./IdentityForm.vue?vue&type=script&lang=ts"
import style0 from "./IdentityForm.vue?vue&type=style&index=0&id=3b190718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b190718",
  null
  
)

export default component.exports